import React from 'react';
import { Gift } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.ebookbtnlines.shop/cart/45562585514031:1';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/cnhcVy6n5bKoNmmUSeGAJR/IMG_6523.png',
  title: '50 ejercicios mentales para runners de menos de 3 minutos.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8kVNfLrbqzZa5STCFTcMhr/IMG_6527.png',
  title: 'Protocolos mentales para 5K, 10K, 21K y 42K.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/cCNjkQoFqHzEJvVBpWL3qv/IMG_6525.png',
  title: 'Diario del corredor: registro mental y emocional de 90 días.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/erYu9gZE3mtayEiH9EUjhn/IMG_6526.png',
  title: '100 frases de autodiálogo para momentos difíciles durante una carrera.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kcLrMv6L4cQ8vX2LDFjUka/IMG_6528.png',
  title: 'Cómo manejar la ansiedad previa a una competición.'
}];
export function Bonuses() {
  return <section id="bonos" className="py-8 px-4 md:px-8 bg-sage-soft" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-5" data-id="element-22">
          <span className="text-forest font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-23">
            Regalos incluidos
          </span>
          <h2 className="font-display font-bold text-3xl md:text-5xl text-ink" data-id="element-24">
            BONOS EXCLUSIVOS
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-25">
          {bonuses.map((bono, idx) => <a key={idx} href={CHECKOUT_URL} aria-label={`Bono ${idx + 1}: ${bono.title}`} className="group bg-white rounded-2xl overflow-hidden shadow-sm border border-sage/20 flex flex-col transform transition-all hover:-translate-y-1 hover:shadow-lg cursor-pointer" data-id="element-26">
              {/* Preview image with gradient fade */}
              <div className="relative h-44 overflow-hidden bg-sage-soft" data-id="element-27">
                <img src={bono.image} alt={bono.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" data-id="element-28" />
                {/* Degrade / gradient overlay fading into the card */}
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/30 to-transparent" data-id="element-29" />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-forest text-white text-xs font-bold uppercase tracking-wider py-1.5 px-3 rounded-full shadow" data-id="element-30">
                  <Gift className="w-3.5 h-3.5" data-id="element-31" />
                  Bono {idx + 1}
                </span>
              </div>

              <div className="p-6 pt-4 flex-1 flex items-start" data-id="element-32">
                <h3 className="font-display font-bold text-lg text-ink leading-snug" data-id="element-33">
                  {bono.title}
                </h3>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}